// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__e6R4A","center":"style_center__hVpd3","atEnd":"style_atEnd__FfqA7","atStart":"style_atStart__5A16g","row":"style_row__8oOD2","column":"style_column__8VMi7"};